module.exports = __webpack_public_path__ + "img/system18-details.0e68496d.png";